<template>
  <div>
    <b-card title="Queued Report Download">
      <b-row>
        <b-col
          cols="12"
          lg="6"
          class="my-1 align-items-start"
        >
          <v-select
            v-model="selectedReport"
            :reduce="option => option.key"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            placeholder="Select Required Report"
            :options="reports"
          />
        </b-col>
        <b-col
          md="3"
          class="mt-md-1"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :to="{ name: 'selected-report-download', params: { key: selectedReport} }"
          >
            <feather-icon
              icon="CornerLeftDownIcon"
              class="mr-50"
            />
            <span class="align-middle">Get Reports</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// eslint-disable-next-line import/extensions,camelcase
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    vSelect,
  },
  data() {
    return {
      reports: [
        { key: 'all-order', name: 'All Orders' },
      ],
      selectedReport: '',
    }
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
</style>
